









































import settings from "@/settings.coffee"

export default {
  name: "EstablishmentStateComments"
  props:
    comments: Array
    readOnly: null
  data: ()->
    current_text: ""
  computed:
    settings: ()->
      settings
  methods:
    split: (txt)->
      ret = txt
      if txt
          ret = txt.split(" ")[0]
      return ret
    create_comment: (data)->
      text = @current_text.replace(/(?:\r\n|\r|\n)/g, "<br>")
      @comments.push({
        who: @$store.state.profile.data.fullname
        text: text
        avatar: @$store.state.profile.data.avatar
        posted_on: new Date()
      })
      @$emit("comments:added", @comments)
      @scroll_down
      @current_text = ""
  mounted: ()->
    return
}
